import { NavLink, useLocation } from "react-router-dom";
import { logo } from "../Materials/images";
import { useEffect, useState } from "react";
import { LiaBarsSolid, LiaTimesSolid } from "react-icons/lia";

export default function Navbar(){

    const [showNav, setShowNav] = useState(false);
    const location = useLocation();

    //when navigating to a new route(location change) this effect
    //hides the mobile navigation menu by setting showNav to false.

    useEffect(() => {
        // Scroll to the top of the page.
        setShowNav(false)
    }, [location]);

    function toggleNav(){
        setShowNav(!showNav);
    }
    return (
        <header>
            <nav>
                <div className="nav-left">
                    <div className="logo-container">
                        <NavLink to="/"><img src={logo} alt="Infraworks_Logo" className="logo" /></NavLink>
                    </div>
                </div>

                <div className={showNav ? "nav-right show-nav":"nav-right hide-nav"}>
                    <ul>
                        <li><NavLink to="/">Home</NavLink></li>
                        <li><NavLink to="/about">About Us</NavLink></li>
                        <li><NavLink to="/projects">Projects</NavLink></li>
                        <li><NavLink to="services">Our Services</NavLink></li>
                        <li><NavLink to="/contact">Contact Us</NavLink></li>
                
                    </ul>
                </div>
                {showNav ? <LiaTimesSolid className="menu-btn" onClick={toggleNav}/> :
                    <LiaBarsSolid className="menu-btn" onClick={toggleNav}/>
                }
  
            </nav>
        </header>
    );
}